import { render, staticRenderFns } from "./GroupedAndSortedDocuments.vue?vue&type=template&id=54d0ae41&scoped=true&"
import script from "./GroupedAndSortedDocuments.vue?vue&type=script&lang=js&"
export * from "./GroupedAndSortedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GroupedAndSortedDocuments.vue?vue&type=style&index=0&id=54d0ae41&scoped=true&lang=css&"
import style1 from "./GroupedAndSortedDocuments.vue?vue&type=style&index=1&id=54d0ae41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0ae41",
  null
  
)

export default component.exports